import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './app';
import { FacebookProvider } from 'react-facebook';
import * as serviceWorker from './serviceWorker';

function renderApp() {
    const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;
    ReactDOM.render(
        <FacebookProvider appId="177411645618187" wait={true}>
            <App baseUrl={baseUrl} />
        </FacebookProvider>,
        document.querySelector('#root')
    );
}

renderApp();

if(window.location.hostname === "localhost"){
    serviceWorker.unregister()
}else {
    serviceWorker.register();
}
